import { WWW_PHP_BASE } from '../../constants/endpoints'
import { APPSTATE } from '../../state'
import { fetchStatusResolver } from './utilities'

type WwwPhpParams = Record<string, string | number | undefined>

export interface WwwPhpRequest {
    script: string
    method?: 'GET' | 'POST' | 'PUT'
    query?: WwwPhpParams
    body?: WwwPhpParams
    withToken?: boolean
    signal?: AbortSignal
}

const toSearchParams = (params: WwwPhpParams = {}) => {
    const search = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined) search.append(key, String(value))
    })
    return search
}

export const wwwPhpRequest = async (request: WwwPhpRequest) => {
    const {
        script,
        method = 'POST',
        query,
        body,
        withToken = false,
        signal,
    } = request
    const token = withToken ? (APPSTATE.session?.token ?? '') : undefined
    const search = toSearchParams({
        ...query,
        ...(withToken && !body ? { token } : {}),
    })
    const form = body
        ? toSearchParams({ ...body, ...(withToken ? { token } : {}) })
        : undefined
    const hasQuery = Array.from(search.keys()).length > 0
    const url = `${WWW_PHP_BASE}/${script}${hasQuery ? `?${search}` : ''}`

    const response = await fetch(url, {
        method,
        credentials: 'include',
        signal,
        ...(form
            ? {
                  headers: {
                      'Content-Type':
                          'application/x-www-form-urlencoded;charset=UTF-8',
                  },
                  body: form,
              }
            : {}),
    })
    return fetchStatusResolver(response).text()
}
